function getSlugValue(slug) {
  if (!slug) return '';
  if (typeof slug === 'object') {
    return slug.current || slug.slug || slug._key || '';
  }
  return String(slug);
}

function slugify(str) {
  return String(str || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9-\s]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function normalizeSlugCandidate(value) {
  const raw = getSlugValue(value);

  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
}

function normalizeSlugForCompare(value) {
  return normalizeSlugCandidate(value)
    .trim()
    .toLowerCase()
    .replace(/^\/+|\/+$/g, '')
    .replace(/^jawaab\//, '')
    .replace(/\/+$/g, '');
}

function getFatawaTitle(item) {
  return item?.question || item?.title || (item?.id ? `post-${item.id}` : '');
}

function getFatawaSlug(item) {
  const explicitSlug = getSlugValue(item?.slug);
  if (explicitSlug) return normalizeSlugCandidate(explicitSlug).replace(/^\/+|\/+$/g, '');

  const titleSlug = slugify(getFatawaTitle(item));
  return titleSlug || (item?.id ? String(item.id) : '');
}

function normalizeFatawa(item, apiBase = '') {
  if (!item) return null;

  const title = getFatawaTitle(item);
  const categories = item.category
    ? [
        {
          id: item.category.id,
          title: item.category.title,
          _rawDescription: item.category.description || item.category._rawDescription || '',
          slug: {
            current:
              getSlugValue(item.category.slug) ||
              slugify(item.category.title || String(item.category.id)),
          },
        },
      ]
    : Array.isArray(item.categories)
      ? item.categories.map((cat) => ({
          id: cat.id,
          title: cat.title,
          _rawDescription: cat.description || cat._rawDescription || '',
          slug: {
            current: getSlugValue(cat.slug) || slugify(cat.title || String(cat.id)),
          },
        }))
      : [];

  const author = item.author
    ? {
        id: item.author.id,
        name: item.author.name || item.author.title || 'Unknown',
        slug: {
          current:
            getSlugValue(item.author.slug) ||
            slugify(item.author.name || item.author.title || String(item.author.id)),
        },
        profileImage: item.author.image
          ? {
              url: `${apiBase.replace(/\/+$/, '')}/${item.author.image}`,
              asset: { gatsbyImageData: null },
              alt: item.author.name,
            }
          : item.author.profileImage || null,
        _rawBio: item.author.biography || item.author._rawBio || '',
      }
    : null;

  return {
    id: item.id,
    title,
    question: item.question,
    body: item.answer || item.body || item.content || '',
    answer: item.answer || item.body || item.content || '',
    content: item.content || '',
    _rawBody: item._rawBody || null,
    slug: { current: getFatawaSlug(item) },
    categories,
    category: item.category || null,
    author,
    publishedAt: item.updated_at || item.created_at || item.publishedAt || null,
  };
}

function fatawaMatchesSlug(item, slugFromPath) {
  const target = normalizeSlugForCompare(slugFromPath);
  if (!item || !target) return false;

  const candidates = [
    getSlugValue(item.slug),
    getFatawaSlug(item),
    slugify(item.question || item.title || ''),
    item.id ? String(item.id) : '',
  ];

  return candidates.some((candidate) => normalizeSlugForCompare(candidate) === target);
}

module.exports = {
  fatawaMatchesSlug,
  getFatawaSlug,
  getFatawaTitle,
  getSlugValue,
  normalizeFatawa,
  normalizeSlugForCompare,
  slugify,
};
